import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDestinationPin = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	viewBox: "0 0 15 22",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M9.70833 8.24967C9.70833 8.85746 9.46689 9.44036 9.03712 9.87013C8.60735 10.2999 8.02445 10.5413 7.41667 10.5413C6.80888 10.5413 6.22598 10.2999 5.79621 9.87013C5.36644 9.44036 5.125 8.85746 5.125 8.24967C5.125 7.64189 5.36644 7.05899 5.79621 6.62922C6.22598 6.19945 6.80888 5.95801 7.41667 5.95801C8.02445 5.95801 8.60735 6.19945 9.03712 6.62922C9.46689 7.05899 9.70833 7.64189 9.70833 8.24967Z",
		stroke: "#FF6D41",
		strokeWidth: 1.2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M12.9171 18.333C12.9171 19.3459 10.4549 20.1663 7.41711 20.1663C4.37927 20.1663 1.91711 19.3459 1.91711 18.333M8.56936 16.0358C8.25973 16.3337 7.84677 16.5001 7.41711 16.5001C6.98745 16.5001 6.57448 16.3337 6.26486 16.0358C3.43327 13.2923 -0.36081 10.2278 1.48902 5.77834C2.49094 3.37209 4.89261 1.83301 7.41711 1.83301C9.94161 1.83301 12.3442 3.37301 13.3452 5.77834C15.1932 10.2214 11.4083 13.3014 8.56936 16.0358Z",
		stroke: "#FF6D41",
		strokeWidth: 1.2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgDestinationPin;
